<app-modal>
    <ng-container title>
        <span *ngIf="data.markers.length === 1"
            >{{ 'FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.TITLE_SINGLE' | translate }}
            {{ data.markers[0].number }}</span
        >
        <span *ngIf="data.markers.length > 1"
            >{{ 'FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.TITLE_MULTIPLE' | translate }} ({{
                data.markers.length
            }})</span
        >
    </ng-container>
    <ng-container body>
        <div class="measurement-annotation-section" *ngIf="data.annotation !== undefined">
            <div class="section-header">
                <h5>{{ 'FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.MEASUREMENT_ANNOTATION' | translate }}</h5>
                <button
                    class="edit-btn"
                    *ngIf="!isEditingMeasurementAnnotation"
                    (click)="startEditMeasurementAnnotation()"
                    [title]="'FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.EDIT' | translate"
                >
                    {{ 'FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.EDIT' | translate }}
                </button>
            </div>
            <div class="marker-annotation-edit" *ngIf="isEditingMeasurementAnnotation">
                <textarea
                    class="annotation-textarea"
                    [(ngModel)]="measurementAnnotationDraft"
                    [disabled]="isSavingMeasurementAnnotation"
                    rows="4"
                    [placeholder]="'FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.PLACEHOLDER' | translate"
                ></textarea>
                <div class="edit-actions">
                    <button [disabled]="isSavingMeasurementAnnotation" (click)="cancelEditMeasurementAnnotation()">
                        {{ 'FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.CANCEL' | translate }}
                    </button>
                    <button
                        class="primary"
                        [disabled]="isSavingMeasurementAnnotation"
                        (click)="saveMeasurementAnnotation()"
                    >
                        {{
                            isSavingMeasurementAnnotation
                                ? ('FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.SAVING' | translate)
                                : ('FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.SAVE' | translate)
                        }}
                    </button>
                </div>
            </div>
            <div *ngIf="!isEditingMeasurementAnnotation">
                <p class="annotation-text" *ngIf="data.annotation">{{ data.annotation }}</p>
                <p class="empty-text" *ngIf="!data.annotation">
                    {{ 'FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.NO_ANNOTATION' | translate }}
                </p>
            </div>
        </div>
        <div class="section-divider" *ngIf="data.annotation !== undefined && data.markers.length > 0"></div>
        <div class="marker-list" *ngIf="data.markers.length > 0">
            <div class="marker-item" *ngFor="let marker of data.markers">
                <div class="marker-header">
                    <span class="marker-number"
                        >{{ 'FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.MARKER_PREFIX' | translate }}
                        {{ marker.number }}</span
                    >
                    <div class="marker-header-right">
                        <span class="marker-time">{{ formatTime(marker.time) }}</span>
                        <button
                            class="edit-btn"
                            *ngIf="!isEditing(marker)"
                            (click)="startEdit(marker)"
                            [title]="'FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.EDIT' | translate"
                        >
                            {{ 'FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.EDIT' | translate }}
                        </button>
                    </div>
                </div>
                <div class="marker-annotation-edit" *ngIf="isEditing(marker)">
                    <textarea
                        class="annotation-textarea"
                        [value]="getDraftAnnotation(marker.number)"
                        (input)="onDraftChange(marker.number, $any($event.target).value)"
                        [disabled]="isSaving(marker)"
                        rows="4"
                        [placeholder]="'FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.PLACEHOLDER' | translate"
                    ></textarea>
                    <div class="edit-actions">
                        <button [disabled]="isSaving(marker)" (click)="cancelEdit(marker)">
                            {{ 'FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.CANCEL' | translate }}
                        </button>
                        <button class="primary" [disabled]="isSaving(marker)" (click)="saveMarkerAnnotation(marker)">
                            {{
                                isSaving(marker)
                                    ? ('FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.SAVING' | translate)
                                    : ('FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.SAVE' | translate)
                            }}
                        </button>
                    </div>
                </div>
                <div class="marker-annotation" *ngIf="!isEditing(marker) && marker.annotation">
                    <h5>{{ 'FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.ANNOTATION_LABEL' | translate }}:</h5>
                    <p>{{ marker.annotation }}</p>
                </div>
                <div class="marker-annotation no-annotation" *ngIf="!isEditing(marker) && !marker.annotation">
                    <p class="empty-text">
                        {{ 'FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.NO_ANNOTATION' | translate }}
                    </p>
                </div>
            </div>
        </div>
        <div class="no-markers" *ngIf="data.markers.length === 0">
            <p>{{ 'FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.NO_MARKERS' | translate }}</p>
        </div>
    </ng-container>
    <ng-container footer>
        <button class="primary" (click)="onClose()">
            {{ 'FEATURES.MEASUREMENTS.MARKER_ANNOTATION_MODAL.CLOSE' | translate }}
        </button>
    </ng-container>
</app-modal>
